import React, { Component } from 'react';
import Markdown from 'markdown-to-jsx';
import post0 from './Articles/post0.md'
import post1 from './Articles/post1.md'
import post2 from './Articles/post2.md'
import post3 from './Articles/post3.md'
import post4 from './Articles/post4.md'
import post5 from './Articles/post5.md'
import { Divider, Typography } from '@mui/material';

// Custom component for h2 headers with amber styling
const AmberHeader = ({ children, ...props }) => (
  <Typography 
    variant="h5" 
    component="h2" 
    sx={{
      color: '#FFC107', // Amber color
      fontWeight: 700,
      fontFamily: "'Orbitron', monospace",
      letterSpacing: 1,
      textShadow: '0 0 10px rgba(255, 193, 7, 0.6)',
      marginTop: 3,
      marginBottom: 2
    }}
    {...props}
  >
    {children}
  </Typography>
);

// Custom component for h3 subheaders with amber styling
const AmberSubHeader = ({ children, ...props }) => (
  <Typography 
    variant="h6" 
    component="h3" 
    sx={{
      color: '#FFC107', // Same amber color as main header
      fontWeight: 500,
      fontFamily: "'Rajdhani', sans-serif",
      fontStyle: 'italic',
      letterSpacing: 0.5,
      textShadow: '0 0 8px rgba(255, 193, 7, 0.4)',
      marginTop: 2,
      marginBottom: 1.5
    }}
    {...props}
  >
    {children}
  </Typography>
);

// Markdown options with custom component overrides
const markdownOptions = {
  overrides: {
    h2: AmberHeader,
    h3: AmberSubHeader,
  },
};

class Entry extends Component {
  constructor(props) {
    super(props)

    this.state = {
      post0: "",
      post1: "",
      post2: "",
      post3: "",
      post4: "",
      post5: "",
    }
  }

  componentWillMount() {
    fetch(post0)
      .then((res) => res.text())
      .then((post0) => {
        this.setState({ post0 })
      })
    fetch(post1)
      .then((res) => res.text())
      .then((post1) => {
        this.setState({ post1 })
      })
    fetch(post2)
      .then((res) => res.text())
      .then((post2) => {
        this.setState({ post2 })
      })
    fetch(post3)
      .then((res) => res.text())
      .then((post3) => {
        this.setState({ post3 })
      })
    fetch(post4)
      .then((res) => res.text())
      .then((post4) => {
        this.setState({ post4 })
      })
    fetch(post5)
      .then((res) => res.text())
      .then((post5) => {
        this.setState({ post5 })
      })
  }

  render() {

    let { post0 } = this.state
    let { post1 } = this.state
    let { post2 } = this.state
    let { post3 } = this.state
    let { post4 } = this.state
    let { post5 } = this.state

    return (
      <div className="post">
        <Markdown options={markdownOptions} children={post0} />
        <Divider>END</Divider>
        <br />

        <Markdown options={markdownOptions} children={post1} />
        <Divider>END</Divider>
        <br />

        <Markdown options={markdownOptions} children={post2} />
        <Divider>END</Divider>
        <br />

        <Markdown options={markdownOptions} children={post3} />
        <Divider>END</Divider>
        <br />

        <Markdown options={markdownOptions} children={post4} />
        <Divider>END</Divider>
        <br />

        <Markdown options={markdownOptions} children={post5} />
        <Divider>END</Divider>
        <br />
      </div>
    )
  }
}

export default Entry;